<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="160px">
        <div class="input-box">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码：">
              <el-input v-model="form.socialCode" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
              @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
    <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
    <el-button icon="el-icon-edit" @click="openBox('create')" v-if="showBtn[3].isShow" >创建</el-button>
    <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('jyfpjd')">删除</el-button>
    <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._f"></file_Upload></el-button>
    <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
    <el-button
      type="primary" icon="el-icon-document-remove" v-loading.fullscreen.lock="lodaingTime"
      @click="Filter_export(`${api}/export`,form)" v-if="showBtn[5].isShow">导出数据</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" max-height="550" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :fixed="i<=7" :label="x.value" align="center"></el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="就业扶贫基地管理"
      :visible.sync="centerDialogVisible"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      @close="close"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">岗位信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="基地名称：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="营业执照编号：">
                          <el-input style="width:193px;" v-model="editForm.businessLicenseNumber"></el-input>
                        </el-form-item>
                        <el-form-item prop="socialCode" label="统一社会信用代码：">
                          <el-input style="width:193px;" v-model="editForm.socialCode"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="法人代表或负责人：">
                          <el-input style="width:193px;" v-model="editForm.ownerName"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话:">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="经办时间：">
                          <el-date-picker style="width:193px;" v-model="editForm.dealTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="经办地区：">
                          <el-input style="width:193px;" v-model="editForm.area"></el-input>
                        </el-form-item>
                        <el-form-item label="基地地点：">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                        <el-form-item label="基地级别：">
                          <el-select size="mini" filterable v-model="editForm.baseLevel" placeholder="请选择">
                            <el-option v-for="(x,i) in $public.danweijibie" :key="i" :label="x.label" :value="x.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
  return{
    api: '/user/employmentBase',
    form: {},
    type: '17',
    centerDialogVisible: false,
    tableData: [],
    selectRow: [],
    baseInfo: [
      {key:'province',value:'省'},
      {key:'city',value:'市'},
      {key:'county',value:'县'},
      {key:'town',value:'镇'},
      {key:'village',value:'村'},		
      {key:'name',value:'基地名称'},
      {key:'businessLicenseNumber',value:'营业执照编号'},
      {key:'socialCode',value:'统一社会信用代码'},
      {key:'ownerName',value:'法人代表或负责人'},
      {key:'phone',value:'联系电话'},
      {key:'address',value:'基地地点'},
      {key:'dealTime',value:'经办时间'},
      {key:'area',value:'经办地区'},
      {key:'baseLevel',value:'基地级别'},
    ],
    rules: {
      socialCode: [
        { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
      ],
    },
    isCreate:false,
  }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer
      vm.Filter_file({ api: vm.api, data: vm.form, callback: _d => vm.tableData = _d })
    },

    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.dealTime = new Date(newForm.dealTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village

      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isCreate) {
          this.$api.create(this.api, newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else { this._status(res.data) }
          })
        } else if (valid && !this.isCreate) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`, newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else { this._status(res.data) }
          })
        } else {
          return false
        }
      })
    },
  },
  created() {
    this.isShowBtn("EmploymentBase")//控制操作按钮的显示与隐藏
    this.getArea({ value: { areaId: 0 }, key: 0 })
  }
}
</script>

<style>
.index-header{overflow-x: scroll;}
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.el-textarea .el-textarea__inner{resize: none;}
</style>